import { Box, Typography } from '@mui/material';
import { HeaderContainer } from '@parkchirp/ui-library';
import React, { FC, PropsWithChildren } from 'react';
import useAppContext from '~/hooks/useAppContext';

import RightSideHeader from './RightSideHeader';

type HeaderProps = {} & PropsWithChildren;

const headerStyles = {
	display: 'flex',
	alignItems: 'center',
	marginRight: '10px',
};

const headerInfoStyles = {
	paddingLeft: '15px',
	fontSize: '18px',
};

const Header: FC<HeaderProps> = () => {
	const { headerDetails } = useAppContext();

	return (
		<HeaderContainer id='pca__header'>
			<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
					}}
					id='pca__header-center--title'
				>
					<Box style={headerStyles}>
						<Typography style={headerInfoStyles} variant='body1' data-cy='header-left-top-details-text'>
							{headerDetails?.info ? `${headerDetails.info} |` : null}
						</Typography>
					</Box>
					<Typography variant='body1' data-cy='header-left-bottom-details-text'>
						{headerDetails?.description || null}
					</Typography>
				</div>

				<div id='pca__header-right--actions'>
					<div data-cy='header-right-details-text'>{headerDetails?.leftSideInfo || ''}</div>
					<RightSideHeader />
				</div>
			</div>
		</HeaderContainer>
	);
};

export default Header;
